var _defs, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSimplified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Simplified_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Simplified_svg__a",
    d: "M10 6.6H5.8A1.8 1.8 0 004 8.395v10.811A1.8 1.8 0 005.8 21h7.147a1.8 1.8 0 001.8-1.8v-.763"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Simplified_svg__a",
    d: "M9.3 16.976l6.5 1.754a2 2 0 002.453-1.416l2.68-10.044a2.008 2.008 0 00-1.412-2.446L13.012 3.07a2 2 0 00-2.453 1.416L7.883 14.53A2 2 0 009.3 16.976zM11.4 17.54l3.72-13.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}

export default SvgSimplified;


//////////////////
// WEBPACK FOOTER
// ./src/icons/Simplified.svg
// module id = 466
// module chunks = 101